import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';

import RichEditorContent from 'components/RichEditorContent';

function CmsElementTestimonial(props) {
  const { editMode, index, showElementSettings } = props;

  // CMS Logik via Hook
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // dnd-kit Styles
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  // Calculate UI constants
  const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
  const imageClass = shown ? 'image-shown' : 'image-not-shown-yet';
  const companyName = getParamValue('companyName', '-');
  const isImageLeft = getParamValue('imagePosition', 'top') === 'left';
  const mainColor = getParamValue('mainColor', 'master');

  const innerContent = (
    <div
      id={getMainId()}
      className={`
        ms-testimonial-content
        ${shownClass}
        ${isImageLeft ? 'image-left ' : ''}
        text-${mainColor}
        ${cssClasses}
        ${responsiveClasses}
      `}
      style={getBackgroundStyle()}
      onClick={(e) => editMode && showElementSettings(e, index)}
    >
      {/* Dynamic CSS (Animations/Custom Styles) */}
      {elementStyleTag}

      <div className="ms-testimonial-image m-b-30">
        {getParamValue('imageUrl', false) ? (
          <img
            src={getParamValue('imageUrl')}
            className={`img-circle img-responsive ${imageClass}`}
            alt={getParamValue('author', 'Author')}
          />
        ) : (
          <i
            className={`${imageClass} fa fa-fw ${getParamValue('icon', 'fa-quote-right')}`}
            style={{ color: getParamValue('iconColor', 'inherit') }}
          />
        )}
      </div>

      <div className="ms-testimonial-description">
        <RichEditorContent content={'<p>' + getParamValue('content', '') + '</p>'} />
        <strong className="m-t-15 ms-testimonial-author">{getParamValue('author')}</strong>

        {getParamValue('authorPosition') && (
          <p className="ms-testimonial-meta">
            {getParamValue('authorPosition') + ', '}
            <a href={getParamValue('companyLink', '#' + companyName)}>{companyName}</a>
          </p>
        )}
      </div>

      {getAppendHtml()}
    </div>
  );

  const parallaxData = getParallaxData();

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementTestimonial;
